module.exports = __webpack_public_path__ + "img/m-iphone.15812549.png";